import React, { Component } from "react";
import { connect } from "react-redux";

import { Table, Input, message, Select } from "antd";
import { usrRole } from "../../utils/dataUtil";
import { getSSPAcademicYear, formateDate_YMD } from "../../utils/dateUtil";
import {
  req_list_employees_all_public,
  req_list_ssp_planner_depart,
  req_list_ssp_target_principal,
  req_list_ssp_school_source_detail,
  req_list_ssp_school_source_main_academicSystem,
  req_add_school_plan_detail,
} from "../../api";

class StudentDepartmentSeniorEditList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    employees: [],
    data: [],
    rows: [],
    row: {
      Gid: "",
      YearMonth: "",
      PlanAcademicYear: "",
      AcademicSystem: "四技",
      UniversityCode: "1051",
      CollegeCode: "",
      TargetDepartmentCode: "",
      PrincipalCode: "",
      SourceCode: "",
      HighSchoolCode: "",
      SourceDepartmentCode: "",
      NumberOfPeople: 0,
      RecordCreatorId: "",
      RecordEditorId: "",
    },
    obj: {},
    colleges: [
      // { label: "管理學院", value: "59" },
      { label: "民生暨管理學院", value: "60" },
      { label: "設計學院", value: "62" },
      { label: "藝術學院", value: "63" },
      // { label: "旅遊學院", value: "193" },
    ],
    targetdeparts: [
      { value: "187", label: "應用英語系", group: "60" },
      { value: "196", label: "旅館管理系", group: "60" },
      { value: "214", label: "養生休閒管理系", group: "60" },
      { value: "161", label: "企業管理系", group: "60" },
      { value: "24", label: "資訊管理系", group: "60" },
      { value: "7", label: "國際企業經營系", group: "60" },
      { value: "8", label: "財務金融系", group: "60" },
      { value: "165", label: "餐飲系", group: "60" },
      { value: "178", label: "生活服務產業系", group: "60" },
      { value: "199", label: "運動休閒與健康管理系", group: "60" },
      { value: "3", label: "服飾設計管理系", group: "60" },
      { value: "4", label: "美容造型設計系", group: "60" },
      { value: "5", label: "幼兒保育系", group: "60" },
      { value: "11", label: "室內設計系", group: "62" },
      { value: "159", label: "時尚設計系", group: "62" },
      { value: "164", label: "多媒體動畫系", group: "62" },
      { value: "17", label: "視覺傳達設計系", group: "62" },
      { value: "18", label: "商品設計系", group: "62" },
      { value: "212", label: "漫畫系", group: "63" },
      { value: "19", label: "美術系", group: "63" },
      { value: "20", label: "音樂系", group: "63" },
      { value: "21", label: "舞蹈系", group: "63" },
      { value: "213", label: "流行音樂系", group: "63" },
    ],
    targetdepartlist: [],
    targetprincipals: [],
    sourcehighSchools: [],
    sourcedeparts: [],
    academicSystems: [
      { label: "四技", value: "四技" },
      { label: "七技", value: "七技" },
    ],
    sourceCodes: [
      { value: "AA", label: "商管群(A)" },
      { value: "AB", label: "餐旅群(A)" },
      { value: "AC", label: "設計群(A)" },
      { value: "AD", label: "藝術群(A)" },
      { value: "AE", label: "機械群(A)" },
      { value: "AF", label: "食品群(A)" },
      { value: "AG", label: "土木群(A)" },
      { value: "AH", label: "外語群英語類(A)" },
      { value: "AI", label: "電子與電機群資電類(A)" },
      { value: "AJ", label: "家政群生活應用類(A)" },
      { value: "AK", label: "家政群幼保類(A)" },
      { value: "AM", label: "農業類(A)" },
      { value: "BA", label: "藝術單招(B1)" },
      { value: "BB", label: "特殊選才(B2)" },
      { value: "BC", label: "繁星入學(B3)" },
      { value: "BD", label: "運優單招(B4)" },
      { value: "BE", label: "一般獨招(B5)" },
      { value: "CA", label: "四技申請(高中生)(C)" },
      { value: "DA", label: "技優甄審(D)" },
    ],
    viewStatus: [
      { value: "NEW", label: "今日新增" },
      { value: "SELF", label: "僅限本人規劃" },
      { value: "ALL", label: "所有數據" },
    ],
    selectedCountyCityName: "NONE",
    selectedCollege: "NONE",
    selectedTargetdepart: "NONE",
    selectedAcademicSystem: "四技",
    selectedTargetprincipal: "NONE",
    selectedSourceCode: "NONE",
    selectedHighSchoolCode: "NONE",
    selectedSourceDepartmentCode: "NONE",
    selectedViewStatus: "NEW",
    canEndable: false,
    todayYMD: formateDate_YMD(new Date()),
    numberOfPeople: 0,
  };

  componentWillMount() {
    this.api_list_depart();
    this.api_list_target_employees();
  }

  //////////
  api_list_target_depart = (value) => {
    const result = this.state.targetdeparts.filter(function (el) {
      return el.group === value;
    });
    const targetdepartlist = result.length > 0 ? result : [];
    this.setState({ targetdepartlist });
    //console.log("targetdepartlist:", targetdepartlist);
  };

  api_list_target_employees = async () => {
    const { role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    const result = await req_list_employees_all_public(userCode, userLevel);
    const employees =
      result.total > 0
        ? result.data.map((employee) => ({
            value: employee.EmployeeId,
            label: employee.TwName,
          }))
        : [];
    // console.log("employees:", employees);
    this.setState({ employees });
  };

  api_list_target_principal = async (targetDepart) => {
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    const result = await req_list_ssp_target_principal(
      userCode,
      userLevel,
      targetDepart,
      token
    );
    const targetprincipals = result.total > 0 ? result.data : [];
    this.setState({ targetprincipals });
    // console.log("targetprincipals:", targetprincipals);
  };

  api_list_source_highSchool = async () => {
    const { planAcademicYear, selectedCountyCityName } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_school_source_main_academicSystem(
      userCode,
      userLevel,
      planAcademicYear,
      selectedCountyCityName,
      "高中",
      token
    );
    const sourcehighSchools = result.total > 0 ? result.data : [];
    this.setState({ sourcehighSchools });
  };

  api_list_source_depart = async () => {
    const { planAcademicYear, selectedHighSchoolCode } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_school_source_detail(
      userCode,
      userLevel,
      planAcademicYear,
      selectedHighSchoolCode,
      token
    );
    //console.log(result.data);

    const sourcedeparts = result.total > 0 ? result.data : [];
    this.setState({ data: [] }, () => {
      if (result.total > 0) {
        const items = result.data;
        const rows = [];
        items.forEach((item) => {
          const row = {
            SourceDepartmentCode: "",
            SourceDepartmentName: "",
            NumberOfPeopleTotalAA: 0,
            NumberOfPeopleTotalAB: 0,
            NumberOfPeopleTotalAC: 0,
            NumberOfPeopleTotalAD: 0,
            NumberOfPeopleTotalAE: 0,
            NumberOfPeopleTotalAF: 0,
            NumberOfPeopleTotalAG: 0,
            NumberOfPeopleTotalAH: 0,
            NumberOfPeopleTotalAI: 0,
            NumberOfPeopleTotalAJ: 0,
            NumberOfPeopleTotalAK: 0,
            NumberOfPeopleTotalAL: 0,
            NumberOfPeopleTotalAM: 0,
            NumberOfPeopleTotalAN: 0,
            NumberOfPeopleTotalAO: 0,
            NumberOfPeopleTotalAP: 0,
            NumberOfPeopleTotalAQ: 0,
            NumberOfPeopleTotalAR: 0,
            NumberOfPeopleTotalAS: 0,
            NumberOfPeopleTotalAT: 0,
            NumberOfPeopleTotalAU: 0,
            NumberOfPeopleTotalAV: 0,
            NumberOfPeopleTotalAW: 0,
            NumberOfPeopleTotalAX: 0,
            NumberOfPeopleTotalAY: 0,
            NumberOfPeopleTotalAZ: 0,
            NumberOfPeopleTotalAll: 0,
          };
          row.SourceDepartmentCode = item.DepartmentCode;
          row.SourceDepartmentName = item.DepartmentName;
          rows.push(row);
        });
        this.setState({ data: rows });
      }
    });
    this.setState({ sourcedeparts });
  };

  api_list_depart = async () => {
    const { planAcademicYear } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_planner_depart(
      userCode,
      userLevel,
      planAcademicYear,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      items.forEach((item) =>
        item.EducationalSystemTwName === "四技"
          ? this.setState({ canEndable: true })
          : ""
      );
      const selectedCollege = items[0].CollegeCode;
      const selectedTargetdepart = items[0].DeptmentRealCode;
      const selectedAcademicSystem = "四技";
      const targetdepartlist = [];
      targetdepartlist.push({
        value: items[0].DeptmentRealCode,
        label: items[0].DeptmentFullName,
      });
      this.setTargetprincipals(items[0].DeptmentRealCode);
      //const lock = result.total === 1 ? true : false;
      const lock = true;
      this.setState({
        loading: false,
        targetdepartlist,
        selectedCollege,
        selectedAcademicSystem,
        selectedTargetdepart,
        lock,
      });
    } else {
      const items = [];
      this.setState({ targetdepartlist: items, loading: false });
    }
  };

  api_add_item = async (item) => {
    const { token } = this.props.user;
    await req_add_school_plan_detail(item, token);
  };

  setTargetdeparts = (value) => {
    this.api_list_target_depart(value);
  };

  setTargetprincipals = (value) => {
    this.api_list_target_principal(value);
  };

  //////////

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "add":
        break;
      default:
    }
  };

  handle_ui_field_change = (target, target_field, e) => {
    let value = e.target.value;
    let getValue = parseInt(value, 10);

    if (isNaN(getValue)) {
      getValue = 0;
    }

    if (getValue <= 100 && getValue >= 0) {
      const { data } = this.state;
      var numberOfPeople = 0;
      var count = 0;
      data.forEach((item, index, arr) => {
        count++;
        if (item.SourceDepartmentCode === target.SourceDepartmentCode) {
          item[target_field] = getValue;
          const total =
            item.NumberOfPeopleTotalAA +
            item.NumberOfPeopleTotalAB +
            item.NumberOfPeopleTotalAC +
            item.NumberOfPeopleTotalAD +
            item.NumberOfPeopleTotalAE +
            item.NumberOfPeopleTotalAF +
            item.NumberOfPeopleTotalAG +
            item.NumberOfPeopleTotalAH +
            item.NumberOfPeopleTotalAI +
            item.NumberOfPeopleTotalAJ +
            item.NumberOfPeopleTotalAK +
            item.NumberOfPeopleTotalAL +
            item.NumberOfPeopleTotalAM +
            item.NumberOfPeopleTotalAN +
            item.NumberOfPeopleTotalAO +
            item.NumberOfPeopleTotalAP +
            item.NumberOfPeopleTotalAQ +
            item.NumberOfPeopleTotalAR +
            item.NumberOfPeopleTotalAS +
            item.NumberOfPeopleTotalAT +
            item.NumberOfPeopleTotalAU +
            item.NumberOfPeopleTotalAV +
            item.NumberOfPeopleTotalAW +
            item.NumberOfPeopleTotalAX +
            item.NumberOfPeopleTotalAY +
            item.NumberOfPeopleTotalAZ;
          item.NumberOfPeopleTotalAll = total;
        }
        numberOfPeople += item.NumberOfPeopleTotalAll;
        if (count === arr.length) {
          this.setState({ numberOfPeople });
        }
      });
      this.setState({ data });
    } else {
      message.info("數字僅能介於0至100");
    }
  };

  //////////
  handleChange = (event) => {
    const { row } = this.state;
    Object.keys(row).forEach((propertyName) => {
      if (event.target.id === propertyName && event.target.value !== null) {
        row[propertyName] = event.target.value.trim();
      }
    });
    this.setState({ row });
    //console.log("handleChange", row);
  };
  //學制
  handleAcademicSystem = (event) => {
    const value = event.target.value;
    this.setState({
      selectedAcademicSystem: value,
    });
  };
  //學院
  handleCollegeChange = (event) => {
    this.setState({
      selectedCollege: event.target.value,
      selectedTargetdepart: "NONE",
      selectedTargetprincipal: "NONE",
    });
    this.setTargetdeparts(event.target.value);
    //console.log(value);
  };
  //系所
  handleTargetdepartChange = (event) => {
    const value = event.target.value;
    this.setState({
      selectedTargetdepart: value,
      selectedTargetprincipal: "NONE",
    });
    //console.log(value);
    this.setTargetprincipals(value);
  };
  //負責人
  // handleTargetprincipalChange = (event) => {
  //   const value = event.target.value;
  //   this.setState({
  //     selectedTargetprincipal: value,
  //   });
  // };
  //生源縣市
  handleselectedCountyCityNameChange = (event) => {
    const value = event.target.value;
    this.setState(
      {
        selectedCountyCityName: value,
        selectedHighSchoolCode: "NONE",
        selectedSourceDepartmentCode: "NONE",
      },
      () => {
        this.api_list_source_highSchool();
      }
    );
  };
  //生源學校
  handleHighSchoolCodeChange = (event) => {
    const value = event.target.value;
    // console.log(value);
    this.setState(
      {
        selectedHighSchoolCode: value,
        selectedSourceDepartmentCode: "NONE",
      },
      () => {
        this.api_list_source_depart();
      }
    );
  };

  handleSave = () => {
    const {
      // planAcademicYear,
      // selectedAcademicSystem,
      // selectedCollege,
      // selectedTargetdepart,
      selectedTargetprincipal,
      selectedCountyCityName,
      selectedHighSchoolCode,
      data,
    } = this.state;
    if (selectedTargetprincipal === "NONE") {
      message.info("請填選負責人");
    } else if (selectedCountyCityName === "NONE") {
      message.info("請選擇生源縣市");
    } else if (selectedHighSchoolCode === "NONE") {
      message.info("請選擇生源學校");
    } else {
      var count = 0;
      data.forEach((item, index, arr) => {
        count++;
        if (item.NumberOfPeopleTotalAll > 0) {
          if (item.NumberOfPeopleTotalAA > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AA",
              item.NumberOfPeopleTotalAA
            );
          }
          if (item.NumberOfPeopleTotalAB > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AB",
              item.NumberOfPeopleTotalAB
            );
          }
          if (item.NumberOfPeopleTotalAC > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AC",
              item.NumberOfPeopleTotalAC
            );
          }
          if (item.NumberOfPeopleTotalAD > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AD",
              item.NumberOfPeopleTotalAD
            );
          }
          if (item.NumberOfPeopleTotalAE > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AE",
              item.NumberOfPeopleTotalAE
            );
          }
          if (item.NumberOfPeopleTotalAF > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AF",
              item.NumberOfPeopleTotalAF
            );
          }
          if (item.NumberOfPeopleTotalAG > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AG",
              item.NumberOfPeopleTotalAG
            );
          }
          if (item.NumberOfPeopleTotalAH > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AH",
              item.NumberOfPeopleTotalAH
            );
          }
          if (item.NumberOfPeopleTotalAI > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AI",
              item.NumberOfPeopleTotalAI
            );
          }
          if (item.NumberOfPeopleTotalAJ > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AJ",
              item.NumberOfPeopleTotalAJ
            );
          }
          if (item.NumberOfPeopleTotalAK > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AK",
              item.NumberOfPeopleTotalAK
            );
          }
          if (item.NumberOfPeopleTotalAL > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AL",
              item.NumberOfPeopleTotalAL
            );
          }
          if (item.NumberOfPeopleTotalAM > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AM",
              item.NumberOfPeopleTotalAM
            );
          }
          if (item.NumberOfPeopleTotalAN > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "N",
              item.NumberOfPeopleTotalAN
            );
          }
          if (item.NumberOfPeopleTotalAO > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AO",
              item.NumberOfPeopleTotalAO
            );
          }
          if (item.NumberOfPeopleTotalAP > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AP",
              item.NumberOfPeopleTotalAP
            );
          }
          if (item.NumberOfPeopleTotalAQ > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AQ",
              item.NumberOfPeopleTotalAQ
            );
          }
          if (item.NumberOfPeopleTotalAR > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AR",
              item.NumberOfPeopleTotalAR
            );
          }
          if (item.NumberOfPeopleTotalAS > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AS",
              item.NumberOfPeopleTotalAS
            );
          }
          if (item.NumberOfPeopleTotalAT > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AT",
              item.NumberOfPeopleTotalAT
            );
          }
          if (item.NumberOfPeopleTotalAU > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AU",
              item.NumberOfPeopleTotalAU
            );
          }
          if (item.NumberOfPeopleTotalAV > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AV",
              item.NumberOfPeopleTotalAV
            );
          }
          if (item.NumberOfPeopleTotalAW > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AW",
              item.NumberOfPeopleTotalAW
            );
          }
          if (item.NumberOfPeopleTotalAX > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AX",
              item.NumberOfPeopleTotalAX
            );
          }
          if (item.NumberOfPeopleTotalAY > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AY",
              item.NumberOfPeopleTotalAY
            );
          }
          if (item.NumberOfPeopleTotalAZ > 0) {
            this.handleSubmit(
              item.SourceDepartmentCode,
              "AZ",
              item.NumberOfPeopleTotalAZ
            );
          }
        }
        if (count === arr.length) {
          this.setState({
            data: [],
            selectedHighSchoolCode: "NONE",
            selectedSourceCode: "NONE",
            selectedSourceDepartmentCode: "NONE",
          });
          message.info("已全部編輯完成");
        }
      });
    }
  };

  handleSubmit = (
    selectedSourceDepartmentCode,
    selectedSourceCode,
    numberOfPeople
  ) => {
    const {
      planAcademicYear,
      selectedCollege,
      selectedTargetdepart,
      selectedTargetprincipal,
      selectedAcademicSystem,
      selectedHighSchoolCode,
    } = this.state;

    const errors = [];

    if (selectedSourceDepartmentCode === "NONE") {
      errors.push("生源科班未選");
    }
    if (selectedSourceCode === "NONE") {
      errors.push("招收方式未選");
    }
    if (numberOfPeople === 0) {
      errors.push("規劃員額不能少於一人");
    }

    if (errors.length === 0) {
      const { userCode } = this.props.user;
      const { row } = this.state;
      row.PlanAcademicYear = planAcademicYear;
      row.CollegeCode = selectedCollege;
      row.AcademicSystem = selectedAcademicSystem;
      row.TargetDepartmentCode = selectedTargetdepart;
      row.PrincipalCode = selectedTargetprincipal;
      row.SourceCode = selectedSourceCode;
      row.HighSchoolCode = selectedHighSchoolCode;
      row.SourceDepartmentCode = selectedSourceDepartmentCode;
      row.NumberOfPeople = numberOfPeople;
      row.RecordEditorId = userCode;
      row.RecordCreatorId = userCode;
      console.log(row);
      this.api_add_item(row);
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  };

  handleEmployeeChange = (value) => {
    console.log(`selected ${value}`);
    this.setState({
      selectedTargetprincipal: value,
    });
  };

  onEmployeeSearch = (value) => {
    //console.log("search:", value);
  };

  render() {
    const {
      planAcademicYear,
      data,
      loading,
      lock,
      academicSystems,
      colleges,
      targetdepartlist,
      // targetprincipals,
      sourcehighSchools,
      selectedAcademicSystem,
      selectedCollege,
      selectedTargetdepart,
      // selectedTargetprincipal,
      selectedCountyCityName,
      selectedHighSchoolCode,
      numberOfPeople,
      employees,
    } = this.state;
    const columns = [
      {
        title: "科班",
        dataIndex: "SourceDepartmentName",
        width: 45,
        align: "center",
        fixed: "left",
        render: (field) => {
          return (
            <>
              <span> {field}</span>
            </>
          );
        },
      },
      {
        title: "小計",
        dataIndex: "NumberOfPeopleTotalAll",
        width: 45,
        align: "center",
        fixed: "left",
        render: (field) => {
          return (
            <>
              <span> {field}</span>
            </>
          );
        },
      },
      {
        title: "商管群",
        dataIndex: "NumberOfPeopleTotalAA",
        width: 40,
        align: "right",
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAA",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: "餐旅群",
        dataIndex: "NumberOfPeopleTotalAB",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAB",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: "設計群",
        dataIndex: "NumberOfPeopleTotalAC",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAC",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: "藝術群",
        dataIndex: "NumberOfPeopleTotalAD",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAD",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: "機械群",
        dataIndex: "NumberOfPeopleTotalAE",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAE",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: "食品群",
        dataIndex: "NumberOfPeopleTotalAF",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAF",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: "土木群",
        dataIndex: "NumberOfPeopleTotalAG",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAG",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: "外語群英語類",
        dataIndex: "NumberOfPeopleTotalAH",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAH",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: "電子與電機群資電類",
        dataIndex: "NumberOfPeopleTotalAI",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAI",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: "家政群生活應用類",
        dataIndex: "NumberOfPeopleTotalAJ",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAJ",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: "家政群幼保類",
        dataIndex: "NumberOfPeopleTotalAK",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAK",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: "農業類",
        dataIndex: "NumberOfPeopleTotalAM",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAM",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: <>藝術 單招</>,
        dataIndex: "NumberOfPeopleTotalAN",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAN",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: <>繁星 運優</>,
        dataIndex: "NumberOfPeopleTotalAX",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAX",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: <>申請 技優</>,
        dataIndex: "NumberOfPeopleTotalAY",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAY",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
      {
        title: "其他",
        dataIndex: "NumberOfPeopleTotalAZ",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {" "}
              <Input
                type="number"
                placeholder="人數"
                style={{ backgroundColor: "LightYellow" }}
                defaultValue={text}
                onChange={(e) =>
                  this.handle_ui_field_change(
                    record,
                    "NumberOfPeopleTotalAZ",
                    e
                  )
                }
              />
            </div>
          );
        },
      },
    ];

    return (
      <>
        <div>
          <div
            style={{
              display: "inline-block",
            }}
          >
            <div className="form-group">
              <Input
                placeholder="規劃年度"
                style={{
                  width: 55,
                  height: 39,
                  margin: "0 5px",
                  color: "red",
                }}
                onChange={(event) =>
                  this.setState({ planAcademicYear: event.target.value })
                }
                value={planAcademicYear}
                readOnly={true}
                disabled={true}
              />
              <select
                className="form-control"
                style={{ width: "80px", display: "inline-block" }}
                onChange={this.handleAcademicSystem}
                disabled={lock}
                value={selectedAcademicSystem}
              >
                <option key={"NONE"} value={"NONE"}>
                  請選擇學制
                </option>
                {academicSystems.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              <select
                className="form-control"
                style={{ width: "160px", display: "inline-block" }}
                onChange={this.handleCollegeChange}
                disabled={lock}
                value={selectedCollege}
              >
                {colleges.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              <select
                className="form-control"
                style={{ width: "180px", display: "inline-block" }}
                onChange={this.handleTargetdepartChange}
                disabled={lock}
                value={selectedTargetdepart}
              >
                <option key={"NONE"} value={"NONE"}>
                  請選擇
                </option>
                {targetdepartlist.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              {/* <select
                className="form-control"
                style={{
                  width: "160px",
                  display: "inline-block",
                  backgroundColor: "LightCyan",
                }}
                onChange={this.handleTargetprincipalChange}
                value={selectedTargetprincipal}
              >
                <option key={"NONE"} value={"NONE"}>
                  請選擇負責人
                </option>
                {targetprincipals.length > 0 ? (
                  <>
                    {targetprincipals.map((item) => (
                      <option key={item.EmployeeId} value={item.EmployeeId}>
                        {item.EmployeeId}-{item.TwName}
                      </option>
                    ))}
                  </>
                ) : (
                  ""
                )}
              </select> */}
              <br></br>
              <div className="form-inline">
                <Select
                  showSearch
                  placeholder="請填選負責人"
                  style={{
                    width: "140px",
                    display: "inline-block",
                  }}
                  className="background-color"
                  onChange={this.handleEmployeeChange}
                  onSearch={this.onEmployeeSearch}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toUpperCase()
                      .includes(input.toUpperCase())
                  }
                  options={employees}
                />
                <select
                  className="form-control"
                  style={{
                    width: 120,
                    backgroundColor: "LightCyan",
                    display: "inline-block",
                  }}
                  onChange={this.handleselectedCountyCityNameChange}
                  value={selectedCountyCityName}
                >
                  <option key="NONE" value="NONE">
                    生源縣市
                  </option>
                  <option value="臺北市" key="臺北市">
                    臺北市
                  </option>
                  <option value="新北市" key="新北市">
                    新北市
                  </option>
                  <option value="基隆市" key="基隆市">
                    基隆市
                  </option>
                  <option value="宜蘭縣" key="宜蘭縣">
                    宜蘭縣
                  </option>
                  <option value="花蓮縣" key="花蓮縣">
                    花蓮縣
                  </option>
                  <option value="臺東縣" key="臺東縣">
                    臺東縣
                  </option>
                  <option value="桃園市" key="桃園市">
                    桃園市
                  </option>
                  <option value="新竹市" key="新竹市">
                    新竹市
                  </option>
                  <option value="新竹縣" key="新竹縣">
                    新竹縣
                  </option>
                  <option value="苗栗縣" key="苗栗縣">
                    苗栗縣
                  </option>
                  <option value="臺中市" key="臺中市">
                    臺中市
                  </option>
                  <option value="彰化縣" key="彰化縣">
                    彰化縣
                  </option>
                  <option value="南投縣" key="南投縣">
                    南投縣
                  </option>
                  <option value="雲林縣" key="雲林縣">
                    雲林縣
                  </option>
                  <option value="嘉義市" key="嘉義市">
                    嘉義市
                  </option>
                  <option value="嘉義縣" key="嘉義縣">
                    嘉義縣
                  </option>
                  <option value="臺南市" key="臺南市">
                    臺南市
                  </option>
                  <option value="高雄市" key="高雄市">
                    高雄市
                  </option>
                  <option value="屏東縣" key="屏東縣">
                    屏東縣
                  </option>
                  <option value="金門縣" key="金門縣">
                    金門縣
                  </option>
                  <option value="連江縣" key="連江縣">
                    連江縣
                  </option>
                  <option value="澎湖縣" key="澎湖縣">
                    澎湖縣
                  </option>
                </select>
                <select
                  className="form-control"
                  style={{
                    width: "160px",
                    display: "inline-block",
                    backgroundColor: "LightCyan",
                  }}
                  onChange={this.handleHighSchoolCodeChange}
                  value={selectedHighSchoolCode}
                >
                  <option key={"NONE"} value={"NONE"}>
                    生源學校
                  </option>
                  {sourcehighSchools.length > 0 ? (
                    <>
                      {sourcehighSchools.map((item) => (
                        <option
                          key={item.HighSchoolCode}
                          value={item.HighSchoolCode}
                        >
                          {item.HighSchoolTwName}
                        </option>
                      ))}
                    </>
                  ) : (
                    ""
                  )}
                </select>
              </div>
            </div>
          </div>
          <Table
            bordered
            columns={columns}
            dataSource={data}
            pagination={false}
            loading={loading}
          />
          <div className="text-right">
            <span style={{ fontWeight: 900, fontSize: "1.5em" }}>
              總計招收：
              <span style={{ color: "red" }}>{numberOfPeople}</span>人
            </span>
          </div>
          <button
            className="btn btn-warning"
            onClick={this.handleSave}
            style={{ width: "100%" }}
          >
            確定送出
          </button>
        </div>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StudentDepartmentSeniorEditList);
